import API from '../../../../API/api';
import { showAction } from '../../../actions/cross_sell_light_box_actions';

const onCrossSellDetailsClick = async (obj) => {
  const lightContent = await API.GET({
    apiPath: `/pdp-light-content-${(obj.spinachId || obj.id).toLowerCase()}.html`,
    data: '',
  });

  obj.lightContent = lightContent.replaceAll('data-original', 'src');
  obj.lightContent = obj.lightContent.replaceAll("data-background-image='", "style='background-image: url(");
  showAction(obj);
};

export default onCrossSellDetailsClick;
